export { Quiz as default } from "./Quiz";